// Where the client talks to the game server.
//
// Normally the page is served by the Warbirds server itself, so requests are
// same-origin and these helpers return plain relative/`location.host` URLs —
// nothing changes. When the client is embedded elsewhere — an itch.io HTML5
// build at https://cameronsima.itch.io/warbirds runs from itch's sandboxed CDN
// origin — the embed's index.html sets `window.__WARBIRDS_SERVER__` to the real
// server's origin (e.g. "https://warbirds.io"). Every HTTP fetch and the
// WebSocket then point back at that origin, which serves the matching CORS
// headers (see internal/server/cors.go) and accepts the cross-origin socket.

// serverBase returns the configured absolute server origin with any trailing
// slash trimmed, or "" for same-origin (the default).
export function serverBase() {
  const b = (typeof window !== "undefined" && window.__WARBIRDS_SERVER__) || "";
  return String(b).replace(/\/+$/, "");
}

// serverURL joins a request path to the configured server base. With no base
// set it returns the path unchanged so requests stay same-origin.
export function serverURL(path) {
  const base = serverBase();
  if (!base) return path;
  return base + (path.startsWith("/") ? path : "/" + path);
}

// wsURL builds the WebSocket URL for /ws, honoring the configured server base.
// An http(s) base is rewritten to the matching ws(s) scheme; with no base set
// it derives ws/wss from the current page like before.
export function wsURL() {
  const base = serverBase();
  if (base) return base.replace(/^http/, "ws") + "/ws";
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}/ws`;
}
